import { connect } from 'react-redux'
import { PackType } from '../../types/pack'
import { AppStateType } from '../../reducers'
import { selectDataFile } from '../../selectors/datafile'
import { selectCapabilitiesSummaryPerGroup } from '../../selectors/capabilitiesSummary'
import { CreateDataFileForm as Component } from './CreateDataFileForm'

const mapStateToProps = (
  state: AppStateType,
  ownProps: { pack: PackType }
) => ({
  datafile: selectDataFile(state),
  capabilitiesSummary: selectCapabilitiesSummaryPerGroup(ownProps.pack.group)(
    state
  ),
})

export const CreateDataFileForm = connect(mapStateToProps)(Component)
